// Recovered compiled webpack factory 27424. Edit this function expression; run npm run build.
(t, e, i) => {
  let n;
  i.d(e, { k: () => a });
  var s = i(40042),
    r = i(73934);
  function o() {
    n = void 0;
  }
  let a = {
    now: () => (
      void 0 === n &&
        a.set(r.uv.isProcessing || s.W.useManualTiming ? r.uv.timestamp : performance.now()),
      n
    ),
    set: (t) => {
      ((n = t), queueMicrotask(o));
    },
  };
}
